export class FilterList {

    protected inputFilter: HTMLInputElement;
    protected list: NodeListOf<HTMLElement>;
    constructor() {
        this.inputFilter = document.querySelector('.js-hvd-filter-list');
        if (this.inputFilter) {
            // HVD-Backend-Filter
            this.validateRegex();
            return;
        }
        if (!document.querySelectorAll('.list').length) {
            return;
        }

        this.init();
    }

    init() {
        this.inputFilter = document.querySelector('.js-filter-list');
        if (!this.inputFilter) {
            return;
        }
        this.list = document.querySelectorAll('.list');

        this.inputFilter.addEventListener('input', this.filterList.bind(this));
    }

    private validateRegex(): void {
        const inputFields = document.querySelectorAll('.js-filter-list');
        inputFields.forEach((input) => {
            input.addEventListener('input', (event) => {
                const target = event.target as HTMLInputElement;
                try {
                    new RegExp(target.value);
                    input.nextElementSibling.classList.add('d-none');
                } catch (e) {
                    input.nextElementSibling.classList.remove('d-none');
                }
            });
        });
    }

    filterList() {
        const filterValue = this.inputFilter.value.toLowerCase();

        this.list.forEach((list: HTMLElement) => {
            const rows = list.querySelectorAll('.row');
            rows.forEach((row: HTMLElement) => {
                const colXsElements = row.querySelectorAll('[class*="col-"]');
                let found = false;

                colXsElements.forEach((col: HTMLElement) => {
                    const text = col.textContent?.toLowerCase() || '';
                    if (text.includes(filterValue)) {
                        found = true;
                    }
                });

                if (found) {
                    row.classList.remove('d-none');
                } else {
                    row.classList.add('d-none');
                }
            });
        });
    }

}

